import { Subject } from 'rxjs';
import { UtilService } from './../../../shared/services/util/util.service';
import { Component, OnInit } from '@angular/core';
import { whyketto } from './crowdfunding-object';
@Component({
  selector: 'app-crowdfunding',
  templateUrl: './crowdfunding.component.html',
  styleUrls: ['./crowdfunding.component.scss']
})
export class CrowdfundingComponent implements OnInit {
  index: Number = 0;
  whyObject = whyketto;
  onSlideChange = new Subject();
  srollAndSlide = new Subject();
  srollAndSlide$ = this.srollAndSlide.asObservable();
  isMobile: any;
  innerIndex;

  constructor(
    public utilService: UtilService
  ) {
    // this.srollAndSlide$ = this.onSlideChange.pipe(
    //   merge(
    //     fromEvent(window, 'scroll'),
    //     this.onSlideChange,
    //   )
    // );
  }

  ngOnInit() {
    this.isMobile = this.utilService.isMobile();
  }

  objectkeys(obj) {
    return Object.keys(obj);
  }

  onNextSlide() {
    this.onSlideChange.next(null);
  }

}
